import classes from "./Home.module.scss";

import PDFCard from "./PDFCard";

export default function HomePage() {
  const links = ["MDS Manual", "Venue Delivery Guide"];

  return (
    <div className={classes.container}>
      <h1>What is MDS?</h1>
      <article>
        <p>
          The Master Delivery Schedule (MDS) system is a critical logistics
          management tool designed specifically for COP29. It serves as a
          centralized platform to oversee and coordinate all deliveries to the
          event site, ensuring that goods and materials are received, processed,
          and distributed efficiently and in compliance with security protocols.
        </p>
        <p>
          Given the complexity and security requirements of COP29, especially
          during restricted access periods such as lockdowns, the MDS system
          plays a pivotal role in scheduling deliveries to avoid disruptions. It
          helps streamline the flow of goods, reduce site congestion, and ensure
          that all deliveries are aligned with operational timelines.
        </p>
        <p>
          The MDS system facilitates real-time communication between logistics
          teams, vendors, and event organizers, offering full transparency and
          enabling proactive decision-making. By providing complete visibility
          into the delivery process, the system ensures smooth logistics
          operations throughout the event, even under heightened security
          measures.
        </p>
      </article>
      <section id="documentation">
        <div className={classes.documentation}>
          <h2>See our documentation:</h2>
          <div className={classes.links}>
            <div style={{ display: "flex" }}>
              {links.length &&
                links.map((link, index) => (
                  <PDFCard title={link} key={`pdf-${index}`} />
                ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
